import { Controller } from '@hotwired/stimulus'

export default class extends Controller<HTMLElement> {
  static targets = ['error']

  declare readonly errorTarget: HTMLElement

  connect(): void {
    this.element.addEventListener('turbo:before-fetch-response', this.onResponse)
    this.element.addEventListener('turbo:fetch-request-error', this.onError)
    this.element.addEventListener('turbo:frame-missing', this.onError)
  }

  disconnect(): void {
    this.element.removeEventListener('turbo:before-fetch-response', this.onResponse)
    this.element.removeEventListener('turbo:fetch-request-error', this.onError)
    this.element.removeEventListener('turbo:frame-missing', this.onError)
  }

  retry(): void {
    this.errorTarget.classList.add('hidden')
    const frame = this.frame
    if (frame === null) return
    this.frameContainer?.classList.remove('hidden')
    frame.reload()
  }

  private get frame(): (HTMLElement & { reload: () => void }) | null {
    return this.element.querySelector('turbo-frame')
  }

  private get frameContainer(): HTMLElement | null {
    return this.frame?.closest('.TURBO_FRAME') ?? this.frame
  }

  private readonly onResponse = (event: Event): void => {
    const { fetchResponse } = (event as CustomEvent).detail
    if (!fetchResponse.response.ok) this.onError(event)
  }

  private readonly onError = (event: Event): void => {
    event.preventDefault()
    this.frameContainer?.classList.add('hidden')
    this.errorTarget.classList.remove('hidden')
  }
}
